import { Outlet } from 'react-router-dom';
import  Header  from './Header';
import { Footer } from './Footer';
import { FooterInforme } from './FooterInforme';

export function GeneralLayout() {
    return (
        <div className="app-page-shell">
            <Header/>
            <main className="app-page-content">
                <Outlet/>
            </main>
            <Footer/>
            {/* Este se usa para generar el footer del reporte en word
            <FooterInforme/>*/}
        </div>
    )
}
